import { render, staticRenderFns } from "./employeeProfileNewLayout.vue?vue&type=template&id=38b5970c&scoped=true"
import script from "./employeeProfileNewLayout.vue?vue&type=script&lang=js"
export * from "./employeeProfileNewLayout.vue?vue&type=script&lang=js"
import style0 from "./employeeProfileNewLayout.vue?vue&type=style&index=0&id=38b5970c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5970c",
  null
  
)

export default component.exports